module.exports = __webpack_public_path__ + "img/p5.89b40963.png";